import React from 'react';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';
import './AISolutions.css';

function AISolutions() {
  usePageTitle('AI Solutions');
  return (
    <div className="ai-solutions">
      <section className="ai-hero">
        <div className="ai-container">
          <h1 className="ai-hero-title">AI Solutions That Drive Business Results</h1>
          <p className="ai-hero-subtitle">Transform operations with intelligent automation, not just chatbots</p>
        </div>
      </section>

      <section className="ai-main">
        <div className="ai-container">
          <div className="ai-solution">
            <h2>💬 AI Chat Agents</h2>
            <p className="ai-desc">Intelligent conversational agents that handle customer inquiries, provide support, and automate repetitive tasks 24/7.</p>
            <div className="ai-benefits">
              <div className="benefit">✓ 80% reduction in support costs</div>
              <div className="benefit">✓ Instant response times</div>
              <div className="benefit">✓ Multi-language support</div>
              <div className="benefit">✓ Seamless human handoff</div>
            </div>
          </div>

          <div className="ai-solution">
            <h2>🎙️ AI Voice Agents</h2>
            <p className="ai-desc">Natural voice interactions for phone support, appointment scheduling, and customer engagement.</p>
            <div className="ai-benefits">
              <div className="benefit">✓ Human-like conversations</div>
              <div className="benefit">✓ Call center automation</div>
              <div className="benefit">✓ Appointment booking</div>
              <div className="benefit">✓ Lead qualification</div>
            </div>
          </div>

          <div className="ai-solution">
            <h2>🧑‍💼 Human-like AI Avatars</h2>
            <p className="ai-desc">Video-based AI avatars that provide personalized customer experiences with facial expressions and natural speech.</p>
            <div className="ai-benefits">
              <div className="benefit">✓ Personalized video interactions</div>
              <div className="benefit">✓ Brand ambassador automation</div>
              <div className="benefit">✓ Training and onboarding</div>
              <div className="benefit">✓ Sales presentations</div>
            </div>
          </div>

          <div className="ai-solution">
            <h2>📚 Enterprise Knowledge Assistant (RAG)</h2>
            <p className="ai-desc">AI systems that understand your company's documents, policies, and knowledge base to provide accurate answers instantly.</p>
            <div className="ai-benefits">
              <div className="benefit">✓ Instant knowledge retrieval</div>
              <div className="benefit">✓ Document Q&A</div>
              <div className="benefit">✓ Policy compliance</div>
              <div className="benefit">✓ Employee self-service</div>
            </div>
          </div>

          <div className="ai-solution">
            <h2>📄 Document Processing AI</h2>
            <p className="ai-desc">Automated extraction, classification, and analysis of documents including invoices, contracts, and medical records.</p>
            <div className="ai-benefits">
              <div className="benefit">✓ 95%+ accuracy</div>
              <div className="benefit">✓ Invoice processing</div>
              <div className="benefit">✓ Contract analysis</div>
              <div className="benefit">✓ Data extraction</div>
            </div>
          </div>

          <div className="ai-solution">
            <h2>📊 Predictive Analytics</h2>
            <p className="ai-desc">Machine learning models that forecast trends, predict customer behavior, and optimize business decisions.</p>
            <div className="ai-benefits">
              <div className="benefit">✓ Sales forecasting</div>
              <div className="benefit">✓ Churn prediction</div>
              <div className="benefit">✓ Demand planning</div>
              <div className="benefit">✓ Risk assessment</div>
            </div>
          </div>

          <div className="ai-solution">
            <h2>⚙️ Workflow Automation</h2>
            <p className="ai-desc">Agentic AI systems that execute multi-step business processes autonomously across your tools and systems.</p>
            <div className="ai-benefits">
              <div className="benefit">✓ End-to-end automation</div>
              <div className="benefit">✓ Tool integration</div>
              <div className="benefit">✓ Process optimization</div>
              <div className="benefit">✓ 50-70% time savings</div>
            </div>
          </div>
        </div>
      </section>

      <section className="ai-difference">
        <div className="ai-container">
          <h2 className="section-title">Why Our AI Solutions Are Different</h2>
          <div className="difference-grid">
            <div className="diff-card">
              <h3>Production-Ready</h3>
              <p>Not demos or prototypes. We build systems that handle real traffic and business-critical operations.</p>
            </div>
            <div className="diff-card">
              <h3>Measurable ROI</h3>
              <p>Every solution is designed with clear KPIs and delivers measurable business value within 90 days.</p>
            </div>
            <div className="diff-card">
              <h3>Seamless Integration</h3>
              <p>Works with your existing tools, databases, and workflows. No rip-and-replace required.</p>
            </div>
            <div className="diff-card">
              <h3>Scalable Architecture</h3>
              <p>Built to handle growth from day one with cloud-native, microservices architecture.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="ai-cta">
        <div className="ai-container">
          <div className="cta-box">
            <h2>Ready to Implement AI in Your Business?</h2>
            <p>Schedule a consultation to explore which AI solutions fit your needs</p>
            <Link to="/contact" className="btn-primary">Book Consultation</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AISolutions;
